import * as React from "react"
import { SVGProps } from "react"

const IconCloseSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={12}
    height={12}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11 1 1 11M1 1l10 10"
      stroke="#1D5F86"
      strokeWidth={1.667}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default IconCloseSvg
